import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useTrafficFleet() {
  const { plaque, driverName, visible } = useAppSelector((state) => state.trafficFleet);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  console.log(date, "brssb");

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "e422b426-6420-4995-a876-8120b56f657a",
    IncludeNonServiceBranches: false,
    Parameters: {
      "870777ef-7f01-11ef-8d00-1062eb32e4ff": driverName,
      "870777f1-7f01-11ef-8d00-1062eb32e4ff": `${plaque.plaquePart4}${plaque.plaquePart3}${plaque.plaquePart2}${plaque.plaquePart1}`,
      "870777f3-7f01-11ef-8d00-1062eb32e4ff": date.created_after || "2020-6-1",
      "870777f4-7f01-11ef-8d00-1062eb32e4ff": "09:00:00",
      "870777f5-7f01-11ef-8d00-1062eb32e4ff": date.created_before || "2030-6-1",
      "870777f6-7f01-11ef-8d00-1062eb32e4ff": "22:00:00",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [plaque, driverName],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data, "yfhghfh");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}

//  "26afcd22-274a-4282-8a6e-6b2952a3dc42": "34-10-434-55",
